module.exports = __webpack_public_path__ + "img/plus_white.f8f0ecb7.svg";